var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"v-icon",class:[!_vm.width && `v-icon--${_vm.size}`]},[_c('div',{staticClass:"v-icon__scaler",class:[!_vm.width && `v-icon--${_vm.size}`],style:({
      width: !!_vm.width && `${_vm.width}px`,
      height: !!_vm.height && `${_vm.height}px`
    })},[(_vm.src)?_c('img',{attrs:{"src":_vm.src,"alt":_vm.alt}}):_vm._e(),(_vm.name)?_c('Sprite',{attrs:{"name":_vm.name}}):_vm._e()],1),(!!this.$slots.default)?_c('div',{staticClass:"v-icon__content"},[_vm._t("default")],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }